<template>
    <div class="layout-input-birthday marriage-layout-input-birthday">
        <div class="layout-ib-top">
            <!-- 切换公农历部分 -->
            <div class="layout-ib-tab-bar dsp-flex">
                <div class="layout-ib-tab" :class="{ 'cur-tab' : tabIndex == 0 }" @click="toggleTab(0)">公历</div>
                <div class="layout-ib-tab" :class="{ 'cur-tab' : tabIndex == 1 }"  @click="toggleTab(1)">农历</div>
            </div>
            <!-- 切换闰月 -->
            <div class="layout-ibci-sub" v-if="tabIndex == 1 && showRun">
                <span class="layout-ibci-switch-text">闰月</span>
                <van-switch class="layout-ibci-switch" v-model="inputData.run" size="18px" active-color="#D84F32" inactive-color="#eee" />
            </div>
        </div>
        <!-- 年月日时分部分 -->
        <div class="layout-ib-content dsp-flex">
            <!-- year -->
            <div class="layout-ib-content-item">
                <p class="layout-ib-content-item-text">年</p>
                <div class="layout-ibci-input-box">
                    <span class="layout-ibci-input-text">{{inputData['year']}}</span>
					<span v-if="inputFocused[0]" class="layout-ibci-input-cursor"></span>
                </div>
            </div>
            <!-- month -->
            <div class="layout-ib-content-item">
                <p class="layout-ib-content-item-text">月</p>
                <div class="layout-ibci-input-box">
                    <span class="layout-ibci-input-text">{{inputData['month']}}</span>
					<span v-if="inputFocused[1]" class="layout-ibci-input-cursor"></span>
                </div>
            </div>
            <!-- day -->
            <div class="layout-ib-content-item">
                <p class="layout-ib-content-item-text">日</p>
                <div class="layout-ibci-input-box">
                    <span class="layout-ibci-input-text">{{inputData['day']}}</span>
					<span v-if="inputFocused[2]" class="layout-ibci-input-cursor"></span>
                </div>
            </div>
            <!-- hour -->
            <div class="layout-ib-content-item">
                <p class="layout-ib-content-item-text" v-bind:class="{'unknown': inputData.unknownTime}">时</p>
                <div class="layout-ibci-input-box" v-bind:class="{'unknown': inputData.unknownTime}">
                    <span class="layout-ibci-input-text">{{inputData['hour']}}</span>
					<span v-if="inputFocused[3]" class="layout-ibci-input-cursor"></span>
                </div>
                <div class="layout-ibci-input-sub"  @click="toggleUnknown">
                    <i class="iconfont kb-icon" :class="{'icon-unselected' : !inputData.unknownTime, 'icon-selected' : inputData.unknownTime}"></i>小时不详
                </div>
            </div>
            <!-- minute -->
            <div class="layout-ib-content-item layout-ib-content-item-last">
                <p class="layout-ib-content-item-text" v-bind:class="{'unknown': inputData.unknownTime}">分</p>
                <div class="layout-ibci-input-box" v-bind:class="{'unknown': inputData.unknownTime}">
                    <span class="layout-ibci-input-text">{{inputData['minute']}}</span>
					<span v-if="inputFocused[4]" class="layout-ibci-input-cursor"></span>
                </div>
            </div>
			<div class="layout-ib-content-cursor" @click="clickInputCursor"></div>
        </div>
        <!-- 虚拟键盘输入 -->
        <div class="layout-ib-keyboard">
            <div class="kb-box kb-l1 kb-num" @click="clickNum(1)">1</div>
            <div class="kb-box kb-l2 kb-num" @click="clickNum(2)">2</div>
            <div class="kb-box kb-l3 kb-num" @click="clickNum(3)">3</div>
            <div class="kb-box kb-l4" @click="clickDelete"><i class="iconfont icon-jianpanguanbi kb-icon-close"></i></div>
            <div class="kb-box kb-l5 kb-num" @click="clickNum(4)">4</div>
            <div class="kb-box kb-l6 kb-num" @click="clickNum(5)">5</div>
            <div class="kb-box kb-l7 kb-num" @click="clickNum(6)">6</div>
            <div class="kb-box kb-l8" @click="clickConfirm">确定</div>
            <div class="kb-box kb-l9 kb-num" @click="clickNum(7)">7</div>
            <div class="kb-box kb-l10 kb-num" @click="clickNum(8)">8</div>
            <div class="kb-box kb-l11 kb-num" @click="clickNum(9)">9</div>
            <div class="kb-box kb-l13"></div>
            <div class="kb-box kb-l14 kb-num" @click="clickNum(0)">0</div>
            <div class="kb-box kb-l15" @click="clickClear">清空输入</div>
        </div>
    </div>
</template>

<script>
import * as consts from '../../modules/data/base/consts'
import { COLLATE_DATA_MANAGER } from '../../modules/data'
import { PAIPAN } from '../../modules/data/core/paipan'
import { MIX, UA } from '../../modules/utils'
export default {
    name : 'MarriageInputBirthdayPanel',
    props: {
        parentNode: {
            type: Object,
            default() { return {} } 
        }
    },
    components: { },
    computed: {
        inputData() {
            return this.$store.state.timeInputData;
        },
        timeCurrent() {
            return this.$store.state.timeCurrent;
        }
    },
    data(){
        return {
            tabIndex: 0,
            showRun: false,
            tempString: '',
            inputValue: '',
            inputFocused: [false, false, false, false, false],
            curFocusIndex: 0,
            inputKeys: ['year', 'month', 'day', 'hour', 'minute'],
            notesData: {
                'year': '年的取值范围在'+ consts.CONST_START_END_YEAR[0] + '-' + consts.CONST_START_END_YEAR[1] +'之间',
                'month': '月的取值范围在01-12之间',
                'day': '日的取值范围在01-31之间',
                'hour': '时的取值范围在00-23之间',
                'minute': '分的取值范围在00-59之间'
            }
        }
    },
    mounted() {
        this.$bus.on('initIPBPKeyBoard', this.initKeyBoard);
        this.$bus.on('resetIPBPKeyBoard', this.resetKeyBoard);
        setTimeout(() => {
            this.focusInputByIndex(0)
            this.initDom();
        }, 20);
    },
    destroyed() {
        this.$bus.off('initIPBPKeyBoard', this.initKeyBoard);
        this.$bus.off('resetIPBPKeyBoard', this.resetKeyBoard);
    },
    methods:{
        initDom() {
            this.$el.style.width = innerWidth + 'px';
        },
        initKeyBoard() {
            if(!UA.isPcWeChat() && !UA.isPC()) { return; }
            document.removeEventListener('keydown', this.bindKeyDown);
            setTimeout(() => {
                document.addEventListener('keydown', this.bindKeyDown);
            }, 100);
        },
        resetKeyBoard() {
            if(!UA.isPcWeChat() && !UA.isPC()) { return; }
            document.removeEventListener('keydown', this.bindKeyDown);
        },
        bindKeyDown(e) {
            let key = e.key, keyCode = e.keyCode;
            // console.log('bindKeyDown----', key, keyCode)
            if(key.length == 1) {
                let num = parseInt(key);
                    num = !isNaN(num) ? num : undefined;
                if(num || num === 0) {
                    // 按键是数字的时候
                    // console.log(num);
                    this.clickNum(num);
                }
            }else {
                console.log('keyCode------', keyCode)
                switch(keyCode) {
                    case 27: //esc键 清除输入
                        this.clickClear();
                        break;
                    case 8: //back键 删除
                        this.clickDelete();
                        break;
                    case 13: //enter键 确定
                        this.clickConfirm();
                        break;
                    default:
                        break;
                }
            }
        },
        // 切换公历农历
        toggleTab(index) {
            // 切换公历农历的时候转换时间:fix一直点击农历or公历一直在变
            if(index != this.tabIndex){
                this.formatDate(index);
            }
            this.tabIndex = index;
            var temp = this.tabIndex == 0 ? false : true;
            this.$set(this.inputData, 'isLunar', temp);
        },
        formatDate(index) {
            if(this.inputData.year != '' && this.inputData.month != '' && this.inputData.day != ''){
                var y = parseInt(this.inputData.year),
                    m = parseInt(this.inputData.month),
                    d = parseInt(this.inputData.day);
                if(index == 0){
                    // 农历转阳历
                    var isRun = this.inputData.run ? 1 : 0;
                    var solarTime = PAIPAN.Lunar2Solar(y, m, d, isRun)
                    this.$set(this.inputData, 'year', solarTime.y)
                    this.$set(this.inputData, 'month', solarTime.m)
                    this.$set(this.inputData, 'day', parseInt(solarTime.d))
                    console.log('公历时间------', isRun, solarTime)
                }else if(index == 1){
                    // 阳历转农历
                    var lunarTime = PAIPAN.Solar2Lunar(y, m, d)
                    this.$set(this.inputData, 'year', lunarTime.y)
                    this.$set(this.inputData, 'month', lunarTime.m)
                    this.$set(this.inputData, 'day', parseInt(lunarTime.d))
                    this.$set(this.inputData, 'run', lunarTime.r == 1 ? true : false)

                    this.showRun = COLLATE_DATA_MANAGER.checkMonthIsRun(lunarTime.y, lunarTime.m);
                    console.log('农历时间------', lunarTime)
                }
            }
        },
        checkMonthIsRun(year, month) {
		    var tempdata = PAIPAN.Lunar2Solar(year, month, 1, 1);
		    return tempdata ? true : false;
        },
        checkRun() {
            // 农历已经输入了年份和月份的时候检查是否闰月
            if(this.tabIndex == 1 && this.inputData.year.length != 0){
                var year = parseInt(this.inputData.year);
                var month = this.inputData.month == '' ? 0 : parseInt(this.inputData.month);
                this.showRun = COLLATE_DATA_MANAGER.checkMonthIsRun(year, month);
                this.$set(this.inputData, 'run', false)
                console.log('month----', this.inputData.month, this.showRun)
            }
            // 检查一下时间是否有变动
            if(this.parentNode && this.parentNode.name == "Diagram") {
                this.$store.state.timeCurrent = false;
            }
        },
        // 切换"时辰不详"
        toggleUnknown() {
            var temp = this.inputData.unknownTime;
            if(!temp && this.curFocusIndex >= 3) {
				this.curFocusIndex = 2;
                this.focusInputByIndex(this.curFocusIndex);
                // this.$set(this.$store.state.timeInputData, 'hour', '');
                // this.$set(this.$store.state.timeInputData, 'minute', '');
			}
            this.$set(this.inputData, 'unknownTime', !temp);
        },
        // 切换"当前时间"
        toggleCurrentTime() {
            let timeCurrent = this.$store.state.timeCurrent;
            this.$store.state.timeCurrent = !timeCurrent;
            if(!timeCurrent) {
                this.$store.dispatch('initTimeInputData', {from: 'diagram'})
            }
        },
        clickInputCursor(e) {
			var curLeft = e.x, 
				width = parseFloat(innerWidth / 5),
				curIndex = parseInt(curLeft / width);
			console.log('clickInputCursor', curLeft, curIndex);
			this.curFocusIndex = curIndex;
			this.focusInputByIndex(curIndex);
		},
		focusInputByIndex(index) {
            this.inputFocused = [false, false, false, false];
            this.inputFocused[index] = true;
		},
        /**
		 * 点击数字键盘
		 * @param {Object} 数字
		 */
		clickNum(num) {
            if(this.parentNode && this.parentNode.name == 'DiagramEdit') {
                this.$store.state.diagram.formDataEdited = true;
            }
			switch(this.curFocusIndex) {
				case 0:
					var curYear = this.inputData['year'].toString();
						curYear = curYear + num;
					if(curYear.length > 1 && parseInt(curYear) == 0) { return; }
					if(curYear.length <= 4) {
						this.$set(this.$store.state.timeInputData, 'year', curYear);
						if(curYear.length == 4) {
							this.curFocusIndex++;
							this.focusInputByIndex(this.curFocusIndex);
						}
					}
					console.log('year------', curYear, this.inputData['year'])
					break;
				case 1:
					var curMonth = this.inputData['month'].toString();
						curMonth = curMonth + num;
					if(curMonth.length > 1 && parseInt(curMonth) == 0) { return; }
					if(curMonth.length <= 2) {
						this.$set(this.$store.state.timeInputData, 'month', curMonth);
					}
					if(curMonth.length == 1 && parseInt(curMonth) > 1 || curMonth.length == 2 && parseInt(curMonth) <= 12) {
						this.curFocusIndex++;
						this.focusInputByIndex(this.curFocusIndex);
					}
					if(curMonth.length == 2 && parseInt(curMonth) > 12) {
						curMonth = curMonth.slice(0, -1);
						this.$set(this.$store.state.timeInputData, 'month', curMonth);
                    }
                    console.log('month------', this.inputData['month'])
					break;
				case 2:
					var curDay = this.inputData['day'].toString();
						curDay = curDay + num;
					if(curDay.length > 1 && (curDay) == 0) { return; }
					if(curDay.length <= 2) {
						this.$set(this.$store.state.timeInputData, 'day', curDay);
					}
					if(curDay.length == 1 && parseInt(curDay) > 3 || curDay.length == 2 && parseInt(curDay) <= 31) {
						this.curFocusIndex++;
						this.focusInputByIndex(this.curFocusIndex);
					}
					if(curDay.length == 2 && parseInt(curDay) > 31) {
						curDay = curDay.slice(0, -1);
						this.$set(this.$store.state.timeInputData, 'day', curDay);
					}
					console.log('day------', this.inputData['day'])
					break;
				case 3:
					var curHour = this.inputData['hour'].toString();
                    if(curHour.length == 0 || (curHour.length == 1 && parseInt(curHour) <= 2)) {
                        curHour = parseInt(curHour + num) <= 23 ? (curHour + num) : curHour;
                        this.$set(this.$store.state.timeInputData, 'hour', curHour);
                        if(parseInt(curHour) >= 3) {
                            this.curFocusIndex++;
                            this.focusInputByIndex(this.curFocusIndex);
                        }
                    }
					console.log('hour------', this.inputData['hour'])
                    break;
                case 4:
                    var curMinute = this.inputData['minute'].toString();
                    if(curMinute.length == 0 || (curMinute.length == 1 && parseInt(curMinute) <= 6)) {
                        curMinute = parseInt(curMinute + num) <= 59 ? (curMinute + num) : curMinute;
                        this.$set(this.$store.state.timeInputData, 'minute', curMinute);
                    }
                    console.log('minute------', this.inputData['minute'])
                    break;
				default:
					break;
			}
            this.checkRun();
		},
        /**
         * 点击一键清除
         */
        clickClear() {
            this.curFocusIndex = 0;
            this.inputFocused = [true, false, false, false, false];
            this.$store.dispatch('resetTimeInputData', {
                unknownTime: this.inputData.unknownTime,
                isLunar: this.inputData.isLunar
            });
        },
		/**
		 * 点击删除按钮
		 */
		clickDelete() {
            var curKey = this.inputKeys[this.curFocusIndex],
                curValue = this.inputData[curKey].toString();
            if(curValue.length > 0) {
                curValue = curValue.slice(0, -1);
                this.$set(this.$store.state.timeInputData, curKey, curValue);
            }else {
                if(this.curFocusIndex > 0) {
                    this.curFocusIndex--;
                    this.focusInputByIndex(this.curFocusIndex);
                }
            }
            this.checkRun();
        },
		/**
		 * 点击确定
		 */
		clickConfirm() {
			// 做数据校验
			var year = parseInt(this.inputData.year);
			if(isNaN(year) || year == 0 || year < consts.CONST_START_END_YEAR[0] || year > consts.CONST_START_END_YEAR[1]){
			    this.$toast(this.notesData['year']);
			    return;
			}
			var month = parseInt(this.inputData.month);
			if(isNaN(month) || month == 0 || month > 12){
			    this.$toast(this.notesData['month']);
			    return;
			}
			var day = parseInt(this.inputData.day);
			if(isNaN(day) || day == 0 || day > 31){
			    this.$toast(this.notesData['day']);
			    return;
			}
			var hour = parseInt(this.inputData.hour);
			if(!this.inputData.unknownTime && (isNaN(hour) || hour > 23)){
			    this.$toast(this.notesData['hour']);
			    return;
            }
            var minute = parseInt(this.inputData.minute);
            if(!this.inputData.unknownTime){
                if(minute > 59){
                    this.$toast(this.notesData['minute']);
                    return;
                }
                if(this.inputData.minute == ''){
                    this.inputData.minute = 0;
                }
            }
            console.log("confirmFunc-----", this.inputData, this.parentNode);

            this.$store.dispatch('marriage/confirmBirthday', this.inputData);
            setTimeout(() => {
                this.tabIndex = 0;
                this.showRun = false;
                this.$set(this.inputData, 'run', false);
                this.resetKeyBoard();
            }, 100);
		}
    }
}
</script>
